module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("My family calls me George, sometimes Georgie, but my full name is Georgina Danforth Witley. I am familiar with pain, the kind of knowledge that comes with age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Am I dead?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harry?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Don’t answer. If you do, I’ll "), _c('em', [_vm._v("know")]), _vm._v(" I’m dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My left hand rests in soot. When I pat the earth, I come up with a piece of charred bark. Did someone build a fire on this very spot? My coat will be dirty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Soot is not a priority. Not here.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Who are you? The silent inquisitor?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("You’re practically home. Your two-storey house is up the hill, the driveway bare, the front door locked. It’s out of sight, but you know it’s there.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The door wants painting. It’s begun to chip. My ivies will need watering. I was on my way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The ivies are hardy. They’ll survive. The woods are the same that grow outside your back stoop; the treed hill descends.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("I’m in the ravine, then. I’m at the bottom of Spinney’s Ravine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is an outrage. I’ll miss my appointment with the Queen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Surely not. I’ll get up. All I have to do is move.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c152c9f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 102
// module chunks = 0